import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import FieldErrors from 'components/FieldErrors';

function Form({ children, className, serverErrors, ...remainingProps }) {
  return (
    <form
      className={classNames('form', className)}
      {...remainingProps}
    >
      {children}
      <FieldErrors
        className="m-t-xxs"
        errors={serverErrors}
        name="base"
      />
    </form>
  );
}

Form.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  serverErrors: PropTypes.object,
};

export default Form;
